import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiEndpoints } from "../../services/apiConfig";
import axios from "axios";

export const getAssessment = createAsyncThunk(
  "assessment/getAssessment",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(apiEndpoints.getAllAssessments, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;

    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getVendorAssessmentReport = createAsyncThunk(
  "assessment/getVendorAssessmentReport",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(apiEndpoints.getvendorReport, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const assessmentSlice = createSlice({
  name: "assessment",
  initialState: {
    loading: false,
    error: null,
    data: [],
    vendorReportData: [], // add this for vendor report
    vendorReportLoading: false,
    vendorReportError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAssessment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAssessment.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAssessment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getVendorAssessmentReport.pending, (state) => {
        state.vendorReportLoading = true;
        state.vendorReportError = null;
      })
      .addCase(getVendorAssessmentReport.fulfilled, (state, action) => {
        state.vendorReportLoading = false;
        state.vendorReportData = action.payload;
      })
      .addCase(getVendorAssessmentReport.rejected, (state, action) => {
        state.vendorReportLoading = false;
        state.vendorReportError = action.payload;
      });
  },
});

export default assessmentSlice.reducer;
